<mat-toolbar color="primary">
  <span id="dokument-rediger-til-signering-dialog-tittel">
    {{ 'Rediger hvem som skal signere \'{filnavn}\'' |translate: {filnavn: dokumentversjon.filnavn} }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@if (modus() == 'rediger') {
  <form [formGroup]="skjema" (ngSubmit)="bekreftOppdaterSignatarer()" class="rediger-signatarer" data-testid="dokument-send-til-signering-skjema">
    @if (nyeSignatarer().length > 0 || slettedeSignatarer().length > 0) {
      <ropert blokk="false">
        {{ '{antallSlettet} signatarer fjernet, {antallNye} signatarer lagt til.'|translate: {antallSlettet: nyeSignatarer().length, antallNye: slettedeSignatarer().length} }}
      </ropert>
    }
    <mat-dialog-content>
      <fieldset>
        <mat-form-field>
          <mat-label>{{ 'Gruppemedlemmer som skal signere'|translate }}</mat-label>
          <velg-medlemmer [skjemakontroll]="skjema.controls.signatarer" [medlemmer]="valgbareMedlemmer()" data-testid="signatarer-felt">
            <ng-template let-medlem>
              <medlem-listevisning-kompakt [medlem]="medlem">
                @if (harSignert(medlem)) {
                  <span class="medlem-har-signert">
                    <mat-icon inline="true">signature</mat-icon>
                    {{ 'Har signert'|translate }}
                  </span>
                }
              </medlem-listevisning-kompakt>
            </ng-template>
          </velg-medlemmer>
        </mat-form-field>
        <mat-form-field [class.skjult]="nyeSignatarer().length == 0" [@fadeInnUt]="nyeSignatarer().length == 0 ? 'ut':'inn'">
          <mat-label>
            {{"Skriv inn beskjed inkludert i invitasjonen til nye signatarer"|translate }}
          </mat-label>
          <riktekst-redigering [skjemakontroll]="skjema.controls.beskjed" data-testid="beskjed-felt"/>
        </mat-form-field>
      </fieldset>

      <h4>{{ 'Signeringsmåte'|translate }}</h4>
      <p>{{ 'Velg hvordan brukere skal signere dokumentet. Du kan velge en eller flere metoder.'|translate }}</p>
      <signering-velg-aksepterte-metoder [skjemaKontroll]="skjema.controls.signaturmetoder"/>
      @if (skjema.controls.signaturmetoder.hasError('required')) {
        <div class="feilmelding">{{ 'Angi minst én signaturmåte'|translate }}</div>
      }

    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <span>
        <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
        <submit-button [skjema]="skjema" [arbeidPaagaar]="lagrer()" spinnerTekst="{{'Sender...'|translate}}">
          {{ "Oppdater signatarer"|translate }}
        </submit-button>
      </span>
      <mat-checkbox [formControl]="skjema.controls.huskSignaturmetodeValg"
                    [style.visibility]="signaturmetoderEndret()?'visible':'hidden'"
                    matTooltip="{{'Bruk dette som standard ved signering i denne gruppen'|translate}}">
        {{ 'Husk signeringsmåte' | translate }}
      </mat-checkbox>
    </mat-dialog-actions>
  </form>

} @else if (modus() == 'bekreft') {
  <mat-dialog-content class="bekreftelse-rediger-signatarer" data-testid="kvittering">
    <tittel-verdi [tittel]="'Følgende medlemmer blir lagt til som signatarer'|translate" data-testid="signatarer-nye">
      <verdi>
        <medlemmer-listevisning-kompakt [medlemmer]="nyeSignatarer()"/>
        @if (nyeSignatarer().length == 0) {
          <p>{{ 'ingen'|translate }}</p>
        }
      </verdi>
    </tittel-verdi>
    <tittel-verdi [tittel]="'Følgende medlemmer blir fjernet som signatarer'|translate" data-testid="signatarer-fjernede">
      <verdi>
        @for (signatar of slettedeSignatarer(); track signatar.medlem.id) {
          <medlem-listevisning-kompakt [medlem]="signatar.medlem">
            @if (signatar.harSignert) {
              <span class="medlem-har-signert">
                <mat-icon inline="true">signature</mat-icon>
                {{ 'Signert {dato}'|translate: {dato: signatar.signaturinformasjon!.signertDato|zoneddatetime} }}
              </span>
            }
          </medlem-listevisning-kompakt>
        }
        @if (slettedeSignatarer().length == 0) {
          <p>{{ 'ingen'|translate }}</p>
        }
      </verdi>
    </tittel-verdi>

    @if (slettedeSignaturer().length > 0) {
      <inline-melding type="advarsel">
        {{ 'Du er i ferd med å fjerne {antall} signatarer som allerede har signert. Deres signatur vil bli permanent slettet.'|translate: {antall: slettedeSignaturer().length} }}
      </inline-melding>
    }

    @if (valideringsfeil().length > 0) {
      <inline-melding type="feil" voksHorisontalt="true" data-testid="valideringsfeil">
        {{ 'Oppdatering av signeringsinformasjon feilet med følgende:'|translate }}
        <ul>
          @for (feil of valideringsfeil(); track $index) {
            <li>{{ feil }}</li>
          }
        </ul>
      </inline-melding>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="tilbakeTilRedigerSignatarer()">{{ "Tilbake"|translate }}</button>
    <button mat-raised-button color="primary" (click)="oppdaterSignatarer()" [disabled]="lagrer()" [visSpinner]="lagrer()" spinnerTekst="{{'Utfører...'|translate}}" data-testid="lagre-knapp">
      {{ "Utfør oppdatering"|translate }}
    </button>
  </mat-dialog-actions>
}
